<script setup lang="ts" name="FieldBaseErrors">
import FieldBaseError from '~/components/FieldBaseError.vue';

withDefaults(
  defineProps<{
    errors?: string[];
    dataTest?: string;
  }>(),
  {
    errors: () => [],
    dataTest: 'errors',
  },
);
</script>

<template>
  <div>
    <FieldBaseError
      v-for="error in errors"
      :key="error"
      :data-test="dataTest"
      :error="error"
    />
  </div>
</template>
